import { setLogout, logout, Stages, setIsCalProvider } from "../actions/actions";

let stagesHistory = [];
export const historyMiddleware = (store) => (next) => (action) => {
  try {
    if (action.type === "SET_STAGE" || action.type === "LOGOUT") {
      stagesHistory.push(action.stage);
      let stage = action.stage;
      stage = stage && stage === Stages.welcome ? "" : stage.toLowerCase().replace(/_/g, "-");
      window.history.pushState(action.stage, "", window.settings.baseUrl + "#/" + stage);
      let stageTitle = stage.replace(/-/g, "");
      document.title = window.settings.pageTitles.main + " " + window.settings.provider.labels.pageTitles[stageTitle];
    }

    window.onpopstate = (e) => {
      switch (e.state) {
        //   case Stages.sendOtp:
        //     next(logout(Stages.sendOtp));
        //     next(setIsCalProvider(window.isCalProvider));
        //     document.title = window.settings.provider.labels.pageTitles.main + " " + window.settings.provider.labels.pageTitles["sendotp"];
        //     break;
        //   case Stages.verifyOtp:
        case Stages.login:
          next(logout(Stages.login));
          next(setIsCalProvider(window.isCalProvider));
          document.title = window.settings.provider.labels.pageTitles.main + " " + window.settings.provider.labels.pageTitles["login"];
          break;
        case Stages.cards:
          let previousStage = stagesHistory[stagesHistory.length - 1];
          let previousStageName = previousStage.toLowerCase().replace(/_/g, "-");
          let stageTitle = previousStage.toLowerCase().replace(/_/g, "");
          window.history.pushState(e.state, "", window.settings.baseUrl + "#/" + previousStageName);
          document.title = window.settings.provider.labels.pageTitles.main + " " + window.settings.provider.labels.pageTitles[stageTitle];
          //  next(setLogout(null, Stages.sendOtp, window.settings.provider.labels.logoutText));
          next(setLogout(null, Stages.login, window.settings.provider.labels.logoutText));
          break;
        default:
          //  next(logout(Stages.sendOtp));
          next(logout(Stages.login));
          next(setIsCalProvider(window.isCalProvider));
          // document.title = window.settings.provider.labels.pageTitles.main + " " + window.settings.provider.labels.pageTitles["sendotp"];
          document.title = window.settings.provider.labels.pageTitles.main + " " + window.settings.provider.labels.pageTitles["login"];
          break;
      }
    };
  } catch (e) {}
  return next(action);
};



// WEBPACK FOOTER //
// ./src/middlewares/history.js